import type { ICustomerMfeLoaderSettings } from '@servicetitan/contactcenter-agent-inbox-mfe-loader';

/*
 * customer-mfe additions for CCPE-1974 (contactcenter-agent-inbox CCPE-3152 and
 * CCPE-3153). The installed loader predates them, so they are mirrored here.
 * The loader passes its whole settings object to customer-mfe, and the event
 * travels on the loader ref's bus, so both work with the customer-mfe bundle
 * that has them. Import them from the loader once a release with them is
 * installed. An older customer-mfe bundle ignores them.
 */

/** customer-mfe -> host: a job was booked and has settled. Fired once per booking. */
export const BOOKING_COMPLETED_EVENT =
  'contactcenter-agent-inbox:booking-completed';

export interface BookingCompletedPayload {
  jobId: string;
  customerId: string;
  orgNodeId: string | null;
  locationId: string | null;
  isCallAssociated: boolean | null;
}

/**
 * customer-mfe -> host: with `hostStartsBookJob`, the CSR clicked Book Job in
 * the customer view, and the host starts the booking.
 */
export const BOOK_JOB_REQUESTED_EVENT =
  'contactcenter-agent-inbox:book-job-requested';

export interface BookJobRequestedPayload {
  customerId: string;
  /** Empty when the view has no name for the customer. */
  customerName: string;
  orgNodeId: string | null;
  /** The location selected in the customer view; null for "All locations". */
  locationId: string | null;
}

export type CustomerMfeSettings = ICustomerMfeLoaderSettings & {
  /** Sends the Book Job click to the host as `BOOK_JOB_REQUESTED_EVENT` instead of opening Book Job. */
  hostStartsBookJob?: boolean;
  /** The selected location, with a customer seed. */
  locationId?: string;
  /** Opens Book Job at mount, with a customer seed. */
  openBookJob?: boolean;
  /** The seeded customer's name, for "Dismiss this booking?" when `openBookJob` opened Book Job. */
  customerName?: string;
  /** Asks "Dismiss this booking?" instead of "Leave Book Job" when leaving Book Job. */
  dismissBookingConfirm?: boolean;
  /** A booking with no call to link: a booked job shows the plain "Job Booked" toast. */
  noCallToLink?: boolean;
};
